import React from 'react';
import { useIntl } from 'react-intl';

import { getSetting } from '../helpers/Settings';

const LikeWhatYouSee = () => {
  const intl = useIntl();

  if (getSetting('hide_stockpress_branding_shares') || getSetting('cs1')) {
    return null;
  }

  return (
    <div className="like-what-you-see">
      <img
        src="/images/stockpress-logo-alt-v2.png"
        alt="Stockpress"
      />
      <h3>
        {intl.formatMessage({ defaultMessage: 'Like what you see?' })}
      </h3>
      <p>
        {intl.formatMessage({ defaultMessage: 'It\'s more than just file storage. Stockpress is Digital Asset Management, made refreshingly simple—so teams can move faster.' })}
      </p>
      <a href="https://stockpress.co/pl-sign-up/" target="_blank" rel="noreferrer">
        {intl.formatMessage({ defaultMessage: 'Get started for free' })}
      </a>
    </div>
  );
};

export default LikeWhatYouSee;
